import Vue from "vue";
import Router from 'vue-router'
// import Login from '../components/Login.vue'

Vue.use(Router)
{
    // const routesP = [
    //     {
    //         path: '/',
    //         redirect: '/login',
    //         hidden: true,
    //         // component: Login
    //         component: resolve => require(['@/components/Login'], resolve)
    //     },
    //     {
    //         path: '/login',
    //         name: 'Login',
    //         hidden: true,
    //         component: () => import('@/components/Login.vue')
    //     },
    //     {
    //         path: '*',
    //         name: 'NotFound',
    //         hidden: true,
    //         component: () => import('@/components/NotFound')
    //     },
    //     {
    //         path: '/home',
    //         name: '首页',
    //         hidden: false,
    //         component: () => import('@/components/Home'),
    //         children: [
    //             {
    //                 path: '/home/First',
    //                 name: '产品展示',
    //                 hidden: false,
    //                 component: () => import('@/components/First')
    //             },
    //         ]
    //     },

    //     {
    //         path: '/home/product',
    //         name: '产品管理',
    //         // redirect: '/home/product',
    //         // component: Home
    //         // component: () => import('@/components/Home') //路由懒加载
    //         component: resolve => require(['@/components/Home'], resolve), //异步加载
    //         children: [
    //             {
    //                 path: '/home/product',
    //                 name: '产品列表',
    //                 iconClass: '',
    //                 component: () => import('@/components/pruduct/list')
    //             },
    //             ]
    //     },
    //     {
    //         path: '/home/device',
    //         name: '设备管理',
    //         component: () => import('@/components/Home'),
    //         hidden: false,
    //         children: [
    //             {
    //                 path: '/home/device/list',
    //                 name: '设备列表',
    //                 iconClass: '',
    //                 component: () => import('@/components/device/list')
    //             },
    //         ]
    //     },
    //     {
    //         path: '/home/msg',
    //         name: '消息管理',
    //         component: () => import('@/components/Home'),
    //         hidden: false,
    //         children: [
    //             {
    //                 path: '/home/msg/list',
    //                 name: '消息列表',
    //                 iconClass: '',
    //                 component: () => import('@/components/msg/list')
    //             },
    //         ]
    //     },
    // ]

    // const routesM = [
    //     {
    //         path: '/',
    //         name: 'Index',
    //         component: () => import( /* webpackChunkName: “about” */ '../view/Index.vue')
    //     },
    //     {
    //         path: '/home',
    //         name: 'Model',
    //         component: () => import('../view/Home.vue')
    //     },
    //     {
    //         path: '/msg/list',
    //         name: 'Msg',
    //         component: () => import('../view/msg/list.vue')
    //     }
    // ]

    //     var routes = [];
    //     if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|Mozilla)/i))) {
    //     // if (window.innerWidth < 750) {
    //     routes = routesM
    //     } else {
    //     routes = routesP
    //     }

    // const router = new Router({
    //     mode: 'history',
    //     base: process.env.BASE_URL,
    //     routes
    // })

    //  export default router
}
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/index/zh_shouye',
            hidden: true,
            // component: Login
            component: resolve => require(['@/components/Index/zh_shouye.vue'], resolve)
        },
        {
            path: '/login',
            name: 'Login',
            hidden: true,
            component: () => import('@/components/Login.vue')
        },
        {
            path: '*',
            name: 'NotFound',
            hidden: true,
            component: () => import('@/components/NotFound')
        },
        {
            path: '/home',
            name: '首页',
            hidden: false,
            component: () => import('@/components/Home'),
            children: [
                {
                    path: '/home/First',
                    name: '产品展示',
                    hidden: false,
                    component: () => import('@/components/First')
                },
            ]
        },

        {
            path: '/home/user',
            name: '用户管理',
            component: () => import('@/components/Home'),
            hidden: false,
            children: [
                {
                    path: '/home/user/list',
                    name: '用户列表',
                    iconClass: '',
                    component: () => import('@/components/user/list')
                },
            ]
        },

        {
            path: '/home/product',
            name: '产品管理',
            // redirect: '/home/product',
            // component: Home
            // component: () => import('@/components/Home') //路由懒加载
            component: resolve => require(['@/components/Home'], resolve), //异步加载
            children: [
                {
                    path: '/home/product',
                    name: '产品列表',
                    iconClass: '',
                    component: () => import('@/components/pruduct/list')
                },
                {
                    path: '/home/product/remote_control',
                    name: '远程控制系统',
                    iconClass: '',
                    component: () => import('@/components/pruduct/remote_control.vue')
                },
            ]
        },
        {
            path: '/home/device',
            name: '设备管理',
            component: () => import('@/components/Home'),
            hidden: false,
            children: [
                {
                    path: '/home/device/list',
                    name: '设备列表',
                    iconClass: '',
                    component: () => import('@/components/device/list')
                },
            ]
        },
        {
            path: '/home/msg',
            name: '消息管理',
            component: () => import('@/components/Home'),
            hidden: false,
            children: [
                {
                    path: '/home/msg/list',
                    name: '消息列表',
                    iconClass: '',
                    component: () => import('@/components/msg/list')
                },
            ]
        },
        {
            path: '/home/file',
            name: '文件管理',
            component: () => import('@/components/Home'),
            hidden: false,
            children: [
                {
                    path: '/home/file/list',
                    name: '文件列表',
                    iconClass: '',
                    component: () => import('@/components/file/list')
                },
            ]
        },
        {
            path: '/home/feedback',
            name: '建议反馈管理',
            component: () => import('@/components/Home'),
            hidden: false,
            children: [
                {
                    path: '/home/feedback/list',
                    name: '建议反馈列表',
                    iconClass: '',
                    component: () => import('@/components/feedback/list')
                },
            ]
        },
        //公司首页
        {
            path: '/index',
            redirect:'/index/zh_shouye',
            name: '首页2',
            hidden: true,
            component: () => import('@/components/Index.vue'),
            children: [
                {
                    path: '/index/zh_shouye',
                    name: '公司简介',
                    component: () => import('@/components/Index/zh_shouye.vue')
                },
                //产品中心
                {
                    path: '/index/product',
                    redirect:'/index/product/product_ksh',
                    name: '产品中心',
                    component: () => import('@/components/Index/zh_chanping.vue'),
                    children:[
                        {
                            path:'/index/product/product_ksh',
                            name:'可视化工具',
                            component:()=>import('@/components/Index/product/product_ksh.vue'),
                        },
                        {
                            path:'/index/product/product_chubing',
                            name:'除冰机器人',
                            component:()=>import('@/components/Index/product/product_chubing.vue'),
                        },
                        {
                            path:'/index/product/product_pingtai',
                            name:'远端作业平台',
                            component:()=>import('@/components/Index/product/product_pingtai.vue'),
                        },
                        {
                            path:'/index/product/about',
                            name:'关于产品',
                            component:()=>import('@/components/Index/product/about_product.vue')
                        },
                        {
                            path:'/index/product/video',
                            name:'VideoPlayer',
                            component:()=>import('@/components/Index/product/product_video.vue'),
                            props: route => ({ url: route.params.url })
                        },
                    ]
                },
                {
                    path:'/index/jfzbb50_240',
                    name:'剥线器',
                    component:()=>import('@/components/Index/product/jfzbb50_240.vue')
                },
                {
                    path:'/index/jfjd_50240',
                    name:'可视化电动剪刀',
                    component:()=>import('@/components/Index/product/jfjd_50240.vue')
                },
                {
                    path:'/index/jf_bsm8_22',
                    name:'可视化电动扳手',
                    component:()=>import('@/components/Index/product/jfbsm8_22.vue')
                },
                {
                    path:'/index/jf_a1_b3',
                    name:'J型线夹安装器',
                    component:()=>import('@/components/Index/product/jf_a1_b3.vue')
                },
                {
                    path:'/index/jf_chjq100',
                    name:'除冰机器人',
                    component:()=>import('@/components/Index/product/jf_chjq100.vue')
                },
                {
                    path:'/index/jf_chjq100_qikua',
                    name:'除冰机器人',
                    component:()=>import('@/components/Index/product/jf_chjq100_qikua.vue')
                },
                {
                    path:'/index/jf_ydcz_800',
                    name:'便携式远端操作平台',
                    component:()=>import('@/components/Index/product/jf_ydcz_800.vue')
                },
                {
                    path:'/index/video',
                    name:'VideoPlayer2',
                    component:()=>import('@/components/Index/product/product_video.vue'),
                    props: route => ({ url: route.params.url })
                },
                {
                    path:'/index/ceshi',
                    name:'测试',
                    component:()=>import('@/components/Index/ceshi.vue')
                },
                
            ]
        },


    ],

})